import React from 'react';

import { Image, Platform, View } from 'react-native';

import { LockedIcon } from 'assets/images';

import { COLOR } from 'utils/colors';

import styles from './styles';

type Props = {
    playing?: boolean;
    testID?: string;
};

function EpgLockedIcon({ playing, testID }: Props) {
    if (Platform.OS === 'web') {
        return (
            <View style={styles.root}>
                <LockedIcon
                    testID={testID}
                    fill={playing ? COLOR.background : COLOR.NEUTRAL}
                />
            </View>
        );
    }

    return (
        <Image
            testID={testID}
            source={{
                uri: playing ? 'icon_epg_locked_black' : 'icon_epg_locked',
            }}
            style={styles.root}
        />
    );
}

export default React.memo(EpgLockedIcon);
